export default {
    host: '0.0.0.0',
    apiBaseUrl: '',
    apiFeBaseUrl: '1121',
    siteBaseUrl: '',
};
